import {
  BasePatternType,
  BasePatternTypeItem,
  buildPatternTypeConfig
} from './base-pattern-type'

export type UrlPatternType = BasePatternType

export const allUrlPatternTypes: UrlPatternType[] = ['ALL', 'ONLY']

export const urlPatternTypeConfig: Record<UrlPatternType, BasePatternTypeItem> =
  buildPatternTypeConfig('detail_allURLs', 'detail_theseURLs')
